window.addEventListener('load', function () {
    const sidebar = document.querySelector('.dashboard__sidebar');
    const enlaceActual = document.querySelector('.dashboard__enlace--actual');

    if (!sidebar || !enlaceActual) return;

    const sidebarRect = sidebar.getBoundingClientRect();
    const enlaceRect = enlaceActual.getBoundingClientRect();

    const scrollActual = sidebar.scrollTop;
    const posicionRelativa = enlaceRect.top - sidebarRect.top;
    const destino = scrollActual + posicionRelativa - (sidebar.clientHeight / 2) + (enlaceActual.clientHeight / 2);

    sidebar.scrollTo({
        top: destino,
        behavior: 'smooth'
    });
});